import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../../components/PageHeader/PageHeader';
import TransactionTable from '../../../components/TransactionsTable/TransactionTable';

const Transactions = () => {

  const { t } = useTranslation();

  return (
    <Box p={3}>
      <PageHeader title={t('transactions')} subtitle={t('manage_transactions')} />
      <Box mt={2}>
        <TransactionTable showCancelFor="all"/>
      </Box>
    </Box>
  );

};

export default Transactions;
